import { useQuery, gql, QueryResult } from '@apollo/client'

const CHATBOT_TOKEN = gql`
  query retrieveChatbotToken {
    retrieveChatbotToken
  }
`

export const useChatbotToken = (): QueryResult => {
  return useQuery(CHATBOT_TOKEN, { fetchPolicy: 'network-only' })
}

const CHATBOT_URL = gql`
  query retrieveChatbotUrl {
    retrieveChatbotUrl
  }
`
export const useChatbotUrl = (): QueryResult => {
  return useQuery(CHATBOT_URL)
}
